import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../../Config';


const ConsigneeTab = ({ token, user_id, b64id, refresh, OrganisationDetail, OrganisationList, EmployeeList }) => {

    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    //organisation options
    let [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (OrganisationList) {
            let current_id = atob(b64id);
            if (current_id) {
                let arr = [];
                OrganisationList.map(val => { if (val.id !== current_id) { arr.push({ value: val.id, label: `${val.name} (${val?.customerType})` }) } });
                setOrganisationOptions(arr)
            }
        }
    }, [OrganisationList]);

    let [employeeOptions, setEmployeeOptions] = useState([]);
    useEffect(() => {
        if (EmployeeList) {
            let arr = [];
            EmployeeList.map(val => { arr.push({ value: val.user_id, label: `${val.name}` }) });
            setEmployeeOptions(arr)
        }
    }, [EmployeeList])

    const initialValues = {
        customer_id: 1,
        preferred_delivery_handler_for_air: "",
        preferred_delivery_handler_for_lcl: "",
        preferred_delivery_handler_for_fcl: "",
        customer_services_for_sea: "",
        customer_services_for_air: "",
        delivery_coordinator_for_sea: "",
        delivery_coordinator_for_air: "",
        account_manager_for_sea: "",
        account_manager_for_air: "",
        currency_uplift_air_percentage: "",
        currency_uplift_air_value: "",
        currency_uplift_sea_percentage: "",
        currency_uplift_sea_value: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: values => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }

                }
                values.customer_id = atob(b64id)
                axios.post(`${adminMainUrl}/api/organization/consignee-add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });

    useEffect(() => {
        if (OrganisationDetail && OrganisationDetail?.EntityConsignee) {
            formik.setFieldValue("preferred_delivery_handler_for_air", Number(OrganisationDetail?.EntityConsignee?.preferred_delivery_handler_for_air));
            formik.setFieldValue("preferred_delivery_handler_for_lcl", Number(OrganisationDetail?.EntityConsignee?.preferred_delivery_handler_for_lcl));
            formik.setFieldValue("preferred_delivery_handler_for_fcl", Number(OrganisationDetail?.EntityConsignee?.preferred_delivery_handler_for_fcl));
            formik.setFieldValue("customer_services_for_sea", OrganisationDetail?.EntityConsignee?.customer_services_for_sea);
            formik.setFieldValue("customer_services_for_air", OrganisationDetail?.EntityConsignee?.customer_services_for_air);
            formik.setFieldValue("delivery_coordinator_for_sea", OrganisationDetail?.EntityConsignee?.delivery_coordinator_for_sea);
            formik.setFieldValue("delivery_coordinator_for_air", OrganisationDetail?.EntityConsignee?.delivery_coordinator_for_air);
            formik.setFieldValue("account_manager_for_sea", OrganisationDetail?.EntityConsignee?.account_manager_for_sea);
            formik.setFieldValue("account_manager_for_air", OrganisationDetail?.EntityConsignee?.account_manager_for_air);
            formik.setFieldValue("currency_uplift_air_percentage", OrganisationDetail?.EntityConsignee?.currency_uplift_air_percentage);
            formik.setFieldValue("currency_uplift_air_value", OrganisationDetail?.EntityConsignee?.currency_uplift_air_value);
            formik.setFieldValue("currency_uplift_sea_percentage", OrganisationDetail?.EntityConsignee?.currency_uplift_sea_percentage);
            formik.setFieldValue("currency_uplift_sea_value", OrganisationDetail?.EntityConsignee?.currency_uplift_sea_value)
        }
    }, [OrganisationDetail]);




    return (
        <div className='card p-3'>
            <form onSubmit={formik.handleSubmit}>
                <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Prefer Delivery Handler</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-4">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Air
                                            </label>

                                        </div>
                                        <Select
                                            name="preferred_delivery_handler_for_air"
                                            className='custom-selector'
                                            options={organisationOptions}
                                            value={organisationOptions.find(option => option.value === formik.values.preferred_delivery_handler_for_air) || null}
                                            onChange={(selectedOption) => formik.setFieldValue("preferred_delivery_handler_for_air", selectedOption.value)}
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For LCL
                                            </label>

                                        </div>
                                        <Select
                                            name="preferred_delivery_handler_for_lcl"
                                            className='custom-selector'
                                            options={organisationOptions}
                                            value={organisationOptions.find(option => option.value === formik.values.preferred_delivery_handler_for_lcl) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("preferred_delivery_handler_for_lcl", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For FCL
                                            </label>

                                        </div>
                                        <Select
                                            name="preferred_delivery_handler_for_fcl"
                                            className='custom-selector'
                                            options={organisationOptions}
                                            value={organisationOptions.find(option => option.value === formik.values.preferred_delivery_handler_for_fcl) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("preferred_delivery_handler_for_fcl", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Customer Services</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Sea
                                            </label>

                                        </div>
                                        {/* <Select
                                            name="customer_services_for_sea"
                                            className='custom-selector'
                                            options={ApplicableOption}
                                            value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        /> */}
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            name='customer_services_for_sea'
                                            id='customer_services_for_sea'
                                            maxLength={50}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.customer_services_for_sea}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Air
                                            </label>

                                        </div>
                                        {/* <Select
                                            name="customer_services_for_air"
                                            className='custom-selector'
                                            options={ApplicableOption}
                                            value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        /> */}
                                        <input
                                            type="text"
                                            maxLength={50}
                                            className="form-control form-control-sm"
                                            name='customer_services_for_air'
                                            id='customer_services_for_air'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.customer_services_for_air}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Delivery Cordinator</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Sea
                                            </label>

                                        </div>
                                        {/* <Select
                                            name="delivery_coordinator_for_sea"
                                            className='custom-selector'
                                            options={ApplicableOption}
                                            value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        /> */}
                                        <input
                                            type="text"
                                            maxLength={50}
                                            className="form-control form-control-sm"
                                            name='delivery_coordinator_for_sea'
                                            id='delivery_coordinator_for_sea'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.delivery_coordinator_for_sea}
                                        />

                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Air
                                            </label>

                                        </div>
                                        {/* <Select
                                            name="delivery_coordinator_for_air"
                                            className='custom-selector'
                                            options={ApplicableOption}
                                            value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        /> */}
                                        <input
                                            type="text"
                                            maxLength={50}
                                            className="form-control form-control-sm"
                                            name='delivery_coordinator_for_air'
                                            id='delivery_coordinator_for_air'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.delivery_coordinator_for_air}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Account Manager</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Sea
                                            </label>

                                        </div>
                                        <Select
                                            name='account_manager_for_sea'
                                            className='custom-selector'
                                            options={employeeOptions}
                                            value={employeeOptions.find(option => option.value === formik.values.account_manager_for_sea) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("account_manager_for_sea", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Air
                                            </label>

                                        </div>
                                        <Select
                                            name="account_manager_for_air"
                                            className='custom-selector'
                                            options={employeeOptions}
                                            value={employeeOptions.find(option => option.value === formik.values.account_manager_for_air) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("account_manager_for_air", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-4">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Land
                                            </label>

                                        </div>
                                        <Select
                                            name="account_manager_for_land"
                                            className='custom-selector'
                                            options={employeeOptions}
                                            value={employeeOptions.find(option => option.value === formik.values.account_manager_for_land) || null} // Control the value based on Formik's state
                                            onChange={(selectedOption) => formik.setFieldValue("account_manager_for_land", selectedOption.value)} // Set the correct field in Formik
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                </div> */}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Accordion className="accordion-item rounded mb-3">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                            Currency uplift</Accordion.Header>
                        <Accordion.Body>
                            <div className="row">

                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Air
                                            </label>

                                        </div>
                                        <div className="row">
                                            <div className="col-8">

                                                <input
                                                    type="text"
                                                    maxLength={5}
                                                    className="form-control form-control-sm"
                                                    id="currency_uplift_air_value"
                                                    name="currency_uplift_air_value"
                                                    placeholder='Enter For Air'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_air_value}
                                                    onInput={(event) => {
                                                        let value = event.target.value;
                                                        value = value.replace(/[^0-9]/g, '');
                                                        event.target.value = value;
                                                    }}

                                                />
                                            </div>
                                            <div className="col-4">

                                                <select
                                                    className="form-control form-control-sm"
                                                    id="currency_uplift_air_percentage"
                                                    name="currency_uplift_air_percentage"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_air_percentage}
                                                >
                                                    <option value="" disabled></option>
                                                    <option value="%">%</option>
                                                    <option value="-">-</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                For Land
                                            </label>

                                        </div>
                                        <div className="row">
                                            <div className="col-8">

                                                <input
                                                    type="text"
                                                    maxLength={5}
                                                    className="form-control form-control-sm"
                                                    id="currency_uplift_sea_value"
                                                    name="currency_uplift_sea_value"
                                                    placeholder='Enter For Air'
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_sea_value}
                                                    onInput={(event) => {
                                                        let value = event.target.value;
                                                        value = value.replace(/[^0-9]/g, '');
                                                        event.target.value = value;
                                                    }}

                                                />
                                            </div>
                                            <div className="col-4">

                                                <select
                                                    className="form-control form-control-sm"
                                                    id="currency_uplift_sea_percentage"
                                                    name="currency_uplift_sea_percentage"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.currency_uplift_sea_percentage}
                                                >
                                                    <option value="" disabled></option>
                                                    <option value="%">%</option>
                                                    <option value="-">-</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <hr />
                <div className="row justify-content-end mt-3 gap-2">
                    <button className="btn btn-primary text-xs w-fit" type="submit" disableSubmit={disableSubmit}>
                        {disableSubmit ? <> <i className="fas fa-spinner fa-spin"></i>Updating...</> : "Update"}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ConsigneeTab